const CURRENCY = "Tshs";

export function formatPrice(price) {
  return `${CURRENCY} ${Number(price).toLocaleString()}`;
}

export default CURRENCY;
